import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import 'particles.js';
import './BackGrowndParticles.css';

const ParticlesComponent = () => {
  const { isAnyHovered, hoveredColor } = useSelector((state) => state.floatDot);

  // Function to generate the particles.js configuration
  const getParticlesConfig = (color) => ({
    particles: {
      number: {
        value: 120,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: color, // Dynamic color value
      },
      shape: {
        type: 'circle',
        stroke: {
          width: 0,
          color: '#000000',
        },
        polygon: {
          nb_sides: 5,
        },
      },
      opacity: {
        value: 0.5,
        random: false,
        anim: {
          enable: false,
          speed: 1,
          opacity_min: 0.1,
          sync: false,
        },
      },
      size: {
        value: 2,
        random: true,
        anim: {
          enable: false,
          speed: 40,
          size_min: 0.1,
          sync: false,
        },
      },
      line_linked: {
        enable: true,
        distance: 150,
        color: color, // Dynamic color value for links
        opacity: 0.4,
        width: 1,
      },
      move: {
        enable: true,
        speed: 6,
        direction: 'none',
        random: false,
        straight: false,
        out_mode: 'out',
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 1200,
        },
      },
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: {
          enable: true,
          mode: 'repulse',
        },
        onclick: {
          enable: true,
          mode: 'push',
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 400,
          line_linked: {
            opacity: 1,
          },
        },
        bubble: {
          distance: 400,
          size: 40,
          duration: 2,
          opacity: 8,
          speed: 3,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
        },
        push: {
          particles_nb: 4,
        },
        remove: {
          particles_nb: 2,
        },
      },
    },
    retina_detect: false,
  });
  
  useEffect(() => {
    // Function to initialize particles.js
    const initializeParticles = () => {
      window.particlesJS('particles-js', getParticlesConfig(isAnyHovered && hoveredColor ? hoveredColor : '#4b587c'));
    };

    // Destroy existing particles instance if it exists
    if (window.pJSDom && window.pJSDom.length > 0) {
      window.pJSDom[0].pJS.fn.vendors.destroypJS();
      window.pJSDom = [];
    }

    // Reinitialize with the new color
    initializeParticles();

  }, [isAnyHovered, hoveredColor]); // Re-run when these values change

  return (
    <div>
      <div
        id="particles-js"
        className={isAnyHovered ? 'animated-particles' : ''} // Apply the toggled class here
        style={{ position: 'relative', height: '100vh', width: '100%' }}
      ></div>
    </div>
  );
};

export default ParticlesComponent;